import {
  AutoSplit,
  BarcodeScanning,
  BrandedDomains,
  DashboardsViewOnly,
  EnhancedReturns,
  InventorySync,
  ProductCatalog,
  ProductBundles,
  ShippingStrategies,
  InventoryApi,
  ShipStationApiV2,
} from './features';

import { Cubiscan, DropShip, FulfillmentProviderBundle, ODBC } from './add-ons';

export const ReturnRabbit = 'ReturnRabbit';

/**
 * @typedef {(
 * AutoSplit |
 * BarcodeScanning |
 * BrandedDomains |
 * Cubiscan |
 * DashboardsViewOnly |
 * DropShip |
 * EnhancedReturns |
 * FulfillmentProviderBundle |
 * InventorySync |
 * ODBC |
 * ProductBundles |
 * ProductCatalog |
 * ShippingStrategies |
 * ReturnRabbit
 * )} UpsellModalContentCode
 */
export const UpsellModalContentCodes = {
  AutoSplit,
  BarcodeScanning,
  BrandedDomains,
  Cubiscan,
  DashboardsViewOnly,
  DropShip,
  EnhancedReturns,
  FulfillmentProviderBundle,
  InventorySync,
  ODBC,
  ProductBundles,
  ProductCatalog,
  ShippingStrategies,
  ReturnRabbit,
  InventoryApi,
  ShipStationApiV2,
};
